<div id="header" class="mt-xxl">
    <div class="greeting-bar" *ngIf="activeHeading">
        <h1>{{ (activeHeading | translate) }}
        </h1>
    </div>
</div>
